export default __webpack_public_path__ + "static/media/BA.3866140f.svg";